import { AccountResponse } from '../../../shared/models/account/AccountResponse';
import { Paddle } from '@paddle/paddle-js';

export const showCheckout = (paddle: Paddle, priceId: string, accountResponse: AccountResponse) => {
  paddle.Checkout.open({
    items: [{ priceId, quantity: 1 }],
    customer: {
      ...(accountResponse.addressId && {
        address: { id: accountResponse.addressId },
      }),
      ...(accountResponse.businessId && {
        business: { id: accountResponse.businessId },
      }),
      email: accountResponse.email,
    },
    ...(accountResponse.discountId && {
      discountId: accountResponse.discountId,
    }),
    customData: {
      accountId: accountResponse.accountId,
    },
    settings: {
      locale: accountResponse.language,
      displayMode: 'overlay',
      variant: 'one-page',
    },
  });
};

// Transakcja zmiany karty (update-payment-method-transaction) już niesie klienta i custom_data z subskrypcji.
// Przekazanie `customer` tutaj kończy się błędem Paddle.js „The customer cannot be changed for this checkout”.
export const updateCard = (paddle: Paddle, transactionId: string) => {
  paddle.Checkout.open({
    transactionId,
    settings: {
      displayMode: 'overlay',
      variant: 'one-page',
    },
  });
};
